<app-count-box
  icon="fas fa-database"
  [styleClass]="styleClass"
  mode="view"
  [label]="title"
  [text]="text"
  [count]="store.count()"
  severity="secondary" />
